<template>
  <div>
    <!-- 筛选 -->
    <el-form ref="Form" :inline="true" class="searchBoxLine my-search-line" :model="searchForm">
      <el-form-item label="申请单号：" prop="deliveryNum">
        <el-input v-model="searchForm.deliveryNum" placeholder="申请单号" />
      </el-form-item>
      <el-form-item label="合同编号：" prop="masterContractNum">
        <el-input v-model="searchForm.masterContractNum" placeholder="合同编号" @blur="searchForm.masterContractNum = (searchForm.masterContractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="项目名称：" prop="masterProjectName">
        <el-input v-model="searchForm.masterProjectName" placeholder="项目名称" />
      </el-form-item>
      <el-form-item label="申请时间：" prop="startTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="未分配金额：" class="undistributed-money">
        <el-input v-model="searchForm.startAssignAmount" placeholder="填写金额" />
        <span> - </span>
        <el-input v-model="searchForm.endAssignAmount" placeholder="填写金额" />
      </el-form-item>
      <el-form-item>
        <el-button ref="searchBtn" type="primary" :loading="isLoading" @click="initData('search')">
          查询
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="isLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="deliveryNum" label="申请单号" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleNum(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterContractNum" label="合同编号" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleContract(row)">
              {{ row.masterContractNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterProjectName" label="项目名称" align="left" />
        <el-table-column prop="amountSum" label="申请发货金额" align="right" header-align="left" />
        <el-table-column prop="assignAll" label="已分配金额" align="right" header-align="left" />
        <el-table-column prop="unAssignAll" label="未分配金额" align="right" header-align="left" />
        <el-table-column prop="createTime" label="申请时间" align="left" />
        <el-table-column prop="transferFromCode" label="操作" align="left" width="120" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="handleDistribute(row)">
              分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.pageIndex"
        :total="page.total"
        layout="total, prev, pager, next, jumper, sizes"
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>

    <!-- 申请单号 -->
    <requisitionedDetail
      ref="requisitionedDetailRef"
      title="查看发货单信息"
    />
  </div>
</template>

<script>
import requisitionedDetail from '../appliedInvoice/requisitionedDetail.vue';
import { selectBusinessUnAssignList } from '@/API';
export default {
  components: {
    requisitionedDetail
  },

  data () {
    return {
      isLoading: false,
      searchForm: {},
      tableData: [],
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },

  created () {
    this.initData();
  },

  methods: {
    initData (type) {
      this.isLoading = true;
      if (type === 'search') {
        this.page.pageIndex = 1;
      }
      const params = {
        ...this.searchForm,
        ...this.page,
        startTime: this.searchForm.startTime ? `${this.searchForm.startTime} 00:00:00` : '',
        endTime: this.searchForm.endTime ? `${this.searchForm.endTime} 23:59:59` : ''
      };
      selectBusinessUnAssignList(params).then(res => {
        const { data } = res.data;
        this.page.total = data.total;
        this.tableData = data.list;
        this.isLoading = false;
      }).catch(e => {
        console.log(e);
        this.isLoading = false;
      });
    },

    // 申请单号
    handleNum (row) {
      this.$refs.requisitionedDetailRef.openDialog(row);
    },

    // 合同编号
    handleContract (row) {
      const routeUrl = this.$router.resolve({
        name: 'ContractInfo',
        params: { contractNum: row.masterContractNum },
        query: {
          id: row.id,
          masterProjectName: row.masterProjectName,
          distributeFlag: true
        }
      });
      window.open(routeUrl.href, '_blank');
    },

    // 分配
    handleDistribute (row) {
      let parmas = {
        id: row.id,
        masterContractNum: row.masterContractNum,
        deliveryNum: row.deliveryNum
      };
      this.$router.push({ name: 'BatchBase', query: parmas });
    },

    handerSizeChange () {
      this.page.pageIndex = 1;
      this.initData();
    },

    handerCurrentChange () {
      this.initData();
    },

    resetForm () {
      this.searchForm = {};
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.initData();
    }
  }
};
</script>

<style scoped>
  .undistributed-money .el-input{
    width: 120px !important;
  }
</style>

<style lang="scss" scoped>
.my-search-line {
  margin-bottom: 12px;
}
</style>
